import type { Filters } from '@lt/api/dist/methods/explore/types';
import { SuggestedFilters as SuggestedFiltersUI } from '@lt/components';
import { useTranslation } from '@lt/localization';

import React, { useMemo } from 'react';
import { formatPreviousFilters } from './utils';

interface Props {
  filters: Partial<Filters> | null;
  isShown: boolean | null;
  applyPreviousFilters: (filters: Partial<Filters>) => void;
  setIsShowing: (value: boolean) => void;
  isMobile: boolean;
}

const SuggestedFilters = (props: Props) => {
  const { filters, isShown, applyPreviousFilters, setIsShowing, isMobile } =
    props;

  const { t } = useTranslation();
  const label = t('filters.suggested.use');
  const buttonText = t('filters.suggested.apply');

  const formattedFilters = useMemo(
    () => filters && formatPreviousFilters(filters),
    [filters],
  );

  if (!isShown || !filters || !formattedFilters) return null;

  const handleApply = (changedFilters: string[]) => {
    const updatedFilters: Partial<Filters> = {};
    changedFilters.forEach((ids) => {
      ids.split(',').forEach((id) => {
        updatedFilters[id] = filters[id];
      });
    });
    applyPreviousFilters(updatedFilters);
    setIsShowing(false);
  };
  return (
    <SuggestedFiltersUI
      onApply={handleApply}
      onClose={() => setIsShowing(false)}
      label={label}
      filters={formattedFilters}
      isMobile={isMobile}
      buttonText={buttonText}
    />
  );
};

export default SuggestedFilters;
